export const MEMBER_FILTER_ALL = 'all';
export const MEMBER_FILTER_UNASSIGNED = 'unassigned';

export const humanMemberName = (value, fallback = 'Membro') => {
  const name = typeof value === 'string' ? value.trim() : '';
  const looksLikeTechnicalId = name.length >= 16 && !/\s/.test(name) && /[a-z]/.test(name) && /[A-Z]/.test(name) && /\d/.test(name);
  if (!name || /^membro\s*[·•]\s*\S+$/i.test(name) || looksLikeTechnicalId) return fallback;
  return name;
};

export const getMemberLabel = (member) => member?.displayName?.trim() || 'Membro';

export const filterTransactionsByMember = (items, filter) => {
  if (!filter || filter === MEMBER_FILTER_ALL) return items;
  if (filter === MEMBER_FILTER_UNASSIGNED) return items.filter((item) => !item.attributedToUid);
  const uid = filter.startsWith('member:') ? filter.slice(7) : filter;
  return items.filter((item) => item.attributedToUid === uid);
};

export const buildMemberFilterOptions = (members, items) => {
  const active = new Set(members.map((member) => member.uid || member.id));
  const removed = new Map();
  items.forEach((item) => {
    if (item.attributedToUid && !active.has(item.attributedToUid)) {
      removed.set(item.attributedToUid, humanMemberName(item.attributedToNameSnapshot, 'Membro removido'));
    }
  });
  return [
    { key: MEMBER_FILTER_ALL, label: 'Todos' },
    ...members.map((member) => ({ key: `member:${member.uid || member.id}`, label: getMemberLabel(member), uid: member.uid || member.id })),
    { key: MEMBER_FILTER_UNASSIGNED, label: 'Sem atribuição / Família' },
    ...Array.from(removed, ([uid, label]) => ({ key: `member:${uid}`, label, uid, removed: true })),
  ];
};

export const getTransactionAttributionLabel = (item, members = []) => {
  if (!item?.attributedToUid) return 'Família';
  const member = members.find((candidate) => (candidate.uid || candidate.id) === item.attributedToUid);
  return member ? getMemberLabel(member) : humanMemberName(item.attributedToNameSnapshot, 'Membro removido');
};
